import React from 'react'
import Navbar from './Components/Navbar'
import './App.css'
import Home from './Components/Pages/Home/Home'
import About from './Components/Pages/About/About'
import Footer from './Components/Pages/Footer/Footer'


function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <About />
      <Footer/>
    </div>
  )
}

export default App
